import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=279f433a&"
import script from "./Gallery.ts?vue&type=script&lang=ts&"
export * from "./Gallery.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports